import FlightDetails from './FlightDetails';
export default FlightDetails;
